import { render } from "./Sales_Record.vue?vue&type=template&id=2cf5b576&scoped=true"
import script from "./Sales_Record.vue?vue&type=script&lang=js"
export * from "./Sales_Record.vue?vue&type=script&lang=js"

import "./Sales_Record.vue?vue&type=style&index=0&id=2cf5b576&scoped=true&lang=css"
import "./Sales_Record.vue?vue&type=style&index=1&id=2cf5b576&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cf5b576"]])

export default __exports__